<template lang="pug">
.imageComponent(:style="imageStyles")
</template>

<script>
import { publicPath } from '@/../vue.config'

export default {
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    backgroundSize: {
      type: String,
      default: 'cover'
    },
    hasAbsoluteUrl: Boolean
  },
  computed: {
    imageStyles () {
      return {
        backgroundSize: this.backgroundSize,
        backgroundImage: `url('${!this.hasAbsoluteUrl ? publicPath : ''}${this.imageUrl}')`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.imageComponent
  width: 100%
  height: 100%
  background: center no-repeat
  border-radius: inherit
</style>
